import React from 'react'
import { Link } from 'react-router-dom'
import BrandImg from '../../../../Assets/images/logo.svg'

function BrandLogo() {
    return (
        <>
            <Link to='/'>
                <img src={BrandImg} alt="logo" />
            </Link>
        </>
    )
}

export default BrandLogo